<script setup lang="ts">
import { VChip } from 'vuetify/components';
import { BottleneckStatus } from '@/gql/graphql';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const props = defineProps<{ status: BottleneckStatus }>();

const { t } = useI18n({
    messages: {
        nl: {
            bottleneck: 'Bottleneck',
            solved: 'Opgelost',
            escalation: 'Escalatie',
        },
        en: {
            bottleneck: 'Bottleneck',
            solved: 'Solved',
            escalation: 'Escalation',
        },
    },
});

const color = computed(() => {
    switch (props.status) {
        case 'solved':
            return 'primary';
        default:
            return 'neutral-90';
    }
});
</script>

<template>
    <VChip size="small" :color :rounded="false">{{ t(status) }}</VChip>
</template>
